import React from 'react';
import { Button } from "react-bootstrap";
import { Form } from 'react-bootstrap';
const StepOne = ({ setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-md-9">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Personal Information</h5>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Full Name:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Full Name" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Date of Birth:</Form.Label>
                                                <Form.Control type="date" placeholder="Enter Date of Birth" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Phone Number:</Form.Label>
                                                <Form.Control type="text" placeholder="Enter Phone Number" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-6">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email:</Form.Label>
                                                <Form.Control type="email" placeholder="Enter Email" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-lg-12">
                                            <Form.Group className="mb-3">
                                                <Form.Label>Home Address:</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder="Enter Home Address" />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(1)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepOne;
